/**
 * Emr for synchronization of calendars
 */
import Api from "@/providers/Api";
import User from "@/apps/default/User";

export default {
    syncCalendar(user_id) {
        let filters = {}
        let params = {}
        return Api.emrSync(this, filters, {user: user_id})
            .then(results => {
                console.log('Emr:syncCalendar  results=', results)
                return true;
            })
    },
}
